import React from 'react'
import { about, about1, about2, about3, discovery1, discovery2, icon6, logoAbout, product1, product2, product3, product4 } from '../../../assets/images';
import { useTranslation } from 'react-i18next';


const About = () => {
   
  const { t, i18n } = useTranslation();
  return (
      <div className="md:max-w-container max-w-containerSm mx-auto mt-[64px] md:mt-[104px] md:flex justify-between">
   <div className='flex flex-col justify-center md:w-[479px] bg-white rounded-[24px]'>
<img src={logoAbout}></img>
   </div>
   <div className='md:w-[745px] bg-[white] rounded-[24px] py-4 px-6'>
    <p className='md:text-[40px] md:leading-[50px] text-xl font-medium'>{t("Tibbi Turizmin Lideri - HEVO sizi qarşılayır !")}</p>
    <p className='mt-[18px] md:text-[20px]'>{t("HEVO Tibbi Turizm Şirkəti, beynəlxalq tibbi turizm sahəsində etibarlı tərəfdaşınız olaraq, həm öz ölkəmizdə, həm də xarici ölkələrdə nüfuzlu tibbi müəssisələrlə əməkdaşlıq edərək, müştərilərinə fərdi yanaşma, innovativ həllər və tam dəstək təmin edir.")}</p>
   <a href='/why-us'>    <button className='h-[51px] w-full md:w-[164px] rounded-[12px] bg-[#FB8C00] text-white mt-[32px]'>{t("Daha ətraflı")}</button></a>
   </div>
  </div>
  )
}

export default About